<template>
    <div class="projectSeting">
        <a-card class="baseSet" title="基本配置">
            <div class="btns">
                <a-button type="primary" @click="submit()">保存</a-button>
                <a-button style="margin: 0 0 0 15px;" @click="$router.push('/operate/FreeEvaluation')">返回</a-button>
            </div>
            <a-form-model :label-col="{span: 4}"
                          :model="baseForm"
                          :rules="baseRules"
                          labelAlign="right"
                          ref="addForm"
                          class="baseForm">
                <a-form-model-item ref="name" label="项目名称" prop="name">
                    <a-input v-model="baseForm.name" :maxLength="20"/>
                </a-form-model-item>
                <a-form-model-item ref="introduceUri" prop="introduceUri" label="上传详情图">
                    <div class="introduceUpload">
                        <a-upload
                                name="imgFile"
                                list-type="picture-card"
                                class="avatar-uploader"
                                :show-upload-list="false"
                                :headers="headers"
                                :action=" baseURL"
                                @change="changeIntroduce"
                                :before-upload="beforeIntroduce">
                            <div v-if="baseForm.introduceUri">
                                <a-icon v-show="iimgLoading" style="position: absolute; top: 35%;left: 100%;"
                                        type="loading"/>
                                <img style="width: 150px;height: 45px;object-fit: contain" :src="baseForm.introduceUri | filterUrl"
                                     alt="avatar">
                            </div>
                            <div v-else>
                                <a-icon :type="introduceloading ? 'loading' : 'plus'"/>
                            </div>
                        </a-upload>
                    </div>
                </a-form-model-item>
            </a-form-model>
        </a-card>
        <a-card class="contentSet" title="内容配置" v-if="hasInfo">
            <div class="table">
                <a-button type="primary" @click="add()" class="btnAdd" v-permission="`Operate.ProjectSeting.Add`">添加资源
                </a-button>
                <a-table style="min-width: 800px;"
                         :columns="columns"
                         row-key="id"
                         :pagination="tableRelevant.tablePagination"
                         :loading="tableRelevant.tableLoading"
                         :locale="tableRelevant.locale"
                         :dataSource="tableRelevant.tableDataSource">
                    <div slot="age" slot-scope="text, record" class="_flex">
                        {{text.minAge}} - {{text.maxAge}}
                    </div>
                    <div slot="status" slot-scope="text, record" class="_flex" v-auth="`Operate.ProjectSeting.Update`">
                        <a-switch checked-children="开启" un-checked-children="关闭" :checked="text.enabled"
                                  @click="statusChange(text)"/>
                    </div>
                    <div slot="action" slot-scope="text, record" v-permission="`Operate.ProjectSeting.Delete`">
                        <a-popconfirm title="你确定要删除该测评吗？" @confirm="deleteProject(record)" style="color:red;">
                            <a class="red">删除</a>
                        </a-popconfirm>
                    </div>
                </a-table>
            </div>
        </a-card>
        <a-modal
                v-model="selectCourse"
                class="add-resource"
                :centered="true"
                :destroyOnClose="true"
                title="添加资源"
                @ok="selectCourseOk">
            <addCourseResource ref="addCourseResourceTable" :parent="'projectSeting'" :detailId="detailId"/>
        </a-modal>
    </div>

</template>

<script>
    import $Bus from "@/pages/projectImpl/js/eventBus"
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import addCourseResource from "./components/AddCourseResource";
    import Apis from "@/requests/apis";

    const columns = [
        {title: '测评名称', key: "1", dataIndex: 'name'},
        {title: '适用年龄', key: "2", scopedSlots: {customRender: 'age'}},
        {title: '状态', key: "6", scopedSlots: {customRender: 'status'}},
        {title: '操作', key: "7", scopedSlots: {customRender: 'action'}}
    ]

    function getBase64(img, callback) {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    export default {
        name: 'projectSeting',
        components: {
            addCourseResource
        },
        data() {
            const validateUrl = (rule, value, callback) => {
                let reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
                if (!value) {
                    callback(new Error('请填写项目链接'));
                } else if (!reg.test(value)) {
                    callback(new Error('链接格式不正确'));
                } else {
                    callback()
                }
            };
            return {
                type: 'add',
                baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/operate",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                hasInfo: false,
                baseForm: {
                    name: '',
                    introduceUri: '',

                },
                baseRules: {
                    name: [{required: true, message: "请填写项目名称", trigger: "blur"}],
                    introduceUri: [{required: true, message: "请上传详情图", trigger: "blur"}],
                },
                bannerloading: false,
                bimgLoading: false,
                introduceloading: false,
                iimgLoading: false,

                columns,
                tableRelevant: tableRelevant.call(this, this.GetGroupCoursePageList),
                selectCourse: false,
                detailId: 0
            }
        },
        mounted() {
            this.type = this.$route.query.type
            this.setTitle()
            if (this.type == 'edit') {
                this.getDetail()
                this.GetGroupCoursePageList(1)
            }
            if (localStorage.getItem('detailId')) {
                this.getDetail()
                this.GetGroupCoursePageList(1)
            }
        },
        methods: {
            // 设置当前页面title
            setTitle() {
                let currentName = ''
                if (this.type == "edit") {
                    currentName = '编辑项目'
                    $Bus.$emit("pageHeaderTitle", currentName);
                } else {
                    currentName = '添加项目'
                    $Bus.$emit("pageHeaderTitle", currentName);
                }
                const arr = ["首页", "运营中心", {name: "免费测评", path: "/operate/FreeEvaluation"}, currentName];
                $Bus.$emit("pageHeaderBreadcrumb", arr);
            },

            changeIntroduce(info) {
                if (info.fileList[0].response) {
                    this.baseForm.introduceUri = info.fileList[0].response.data
                }
                if (info.file.status === 'uploading') {
                    this.introduceloading = true
                    this.iimgLoading = true
                    return
                }
                if (info.file.status === 'done') {
                    getBase64(info.file.originFileObj, (imageUrl) => {
                        this.baseForm.introduceUri = info.file.response.data
                        this.introduceloading = false
                        this.iimgLoading = false
                        this.$refs.addForm.validateField("introduceUri");
                    })
                }
            },
            beforeIntroduce(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
                if (!isJpgOrPng) {
                    this.$message.error('请上传jpg或者png图片!')
                }
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过2M!')
                }
                return isJpgOrPng && isLt2M
            },

            getDetail() {
                let params = {
                    id: this.$route.query.id || localStorage.getItem('detailId')
                }
                this.$http.operate.GetGroupDetail(params)
                    .then(res => {
                        const {data} = res.data
                        for (let key in this.baseForm) {
                            this.baseForm[key] = data[key]
                        }
                        this.hasInfo = true
                    })
                    .catch(err => {

                    })
            },
            submit() {
                this.$refs.addForm.validate(valid => {
                    if (valid) {
                        this.$message.destroy();
                        let params = {
                            promotionGroupType: 1,
                            ...this.baseForm
                        }
                        if (this.type == 'edit' || this.detailId) {
                            params.id = +this.$route.query.id || this.detailId
                        }
                        this.$http.operate.EditCourseConfigGroup(params)
                            .then(res => {
                                const {data} = res.data
                                this.$message.success('保存成功')
                                this.hasInfo = true
                                this.detailId = data
                                localStorage.setItem('detailId', data);
                            })
                            .catch(err => {

                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            deleteProject(text) {
                this.$message.destroy();
                this.tableRelevant.tableLoading = true
                let formData = new FormData();
                formData.append('id', text.id);
                this.$http.operate.DeleteCourse(formData)
                    .then(res => {
                        this.tableRelevant.tableLoading = false
                        this.$message.success('删除成功')
                        this.GetGroupCoursePageList(1)
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
            statusChange(text) {
                this.$message.destroy();
                let formData = new FormData();
                formData.append('id', text.id)
                this.$http.operate.courseStatusChange(formData)
                    .then(res => {
                        this.$message.success(res.data.data)
                        text.enabled = !text.enabled
                    })
                    .catch(err => {
                    })
            },
            add() {
                this.selectCourse = true
            },
            // 选择课程确定按钮
            selectCourseOk() {
                this.$message.destroy();
                const courseSelectedRow = this.$refs.addCourseResourceTable.$data.courseSelectedRowKeys.map(m => JSON.parse(m));
                if (!courseSelectedRow.length) {
                    this.$message.error("请选择课程");
                    return
                }
                let arr = []
                courseSelectedRow.forEach(v => {
                    arr.push(v.id)
                })
                let params = {
                    name: '',
                    courseIds: arr,
                    description: '',
                    businessScenarioType: 1,
                    groupId: this.$route.query.id || this.detailId
                }
                this.$http.operate.GroupAddCourse(params)
                    .then(res => {
                        this.$message.success('添加成功')
                        this.selectCourse = false
                        this.GetGroupCoursePageList(1)
                    })
                    .catch(err => {

                    })
            },
            // 内容配置列表
            GetGroupCoursePageList(pageIndex) {
                let params = {
                    GroupId: this.$route.query.id || localStorage.getItem('detailId'),
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                }
                this.tableRelevant.tableLoading = true
                this.$http.operate.GetGroupCoursePageList(params)
                    .then(res => {
                        this.tableRelevant.tableLoading = false
                        this.tableRelevant.tableDataSource = res.data.data.items
                        this.tableRelevant.tablePagination.total = res.data.data.totalCount;
                        this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
                    })
                    .catch(err => {
                        this.tableRelevant.tableLoading = false
                    })
            },
        }
    }
</script>

<style scoped lang="less">
    .baseForm {
        width: 50%;
        position: relative;
    }

    .uplod {

        span {
            width: 80px;
            text-align: right;
        }
    }

    .baseForm /deep/ .ant-form-item {
        display: flex;
    }

    .baseForm /deep/ .ant-form-item-control-wrapper {
        width: 80%;
    }

    .contentSet {
        margin-top: 30px;
    }

    .table {
        position: relative;
    }

    .btnAdd {
        position: absolute;
        top: -68px;
        right: 15px;
    }

    .btns {
        position: absolute;
        top: 13px;
        right: 15px;
    }

    .add-resource /deep/ .ant-modal {
        width: 60%;
        min-width: 1100px;
    }

    .introduceUpload {
        position: relative;
    }
</style>
